import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import useSort from "../../hooks/useSort";

//
import { Card, InputGroup, FormControl } from "react-bootstrap";

//
import { getAvailableCoins } from "../../redux/features/coins/actions";

//
import FilterBox from "../../components/general/FilterBox";
import Pagination from "../../components/general/Pagination";
import BoxLoading from "../../components/general/BoxLoading";
import PageHeader from "../../components/general/PageHeader";
import NothingToShow from "../../components/general/NothingToShow";
import ListAvailableCoins from "../../components/available-coins/ListAvailableCoins";
import BoxAvailableCoins from "../../components/available-coins/BoxAvailableCoins";

function AvailableCoins({ windowSize }) {
  const [sort, updateSort] = useSort();

  const [searchBoxStatus, setSearchBoxStatus] = useState(false);
  const [search, setSearch] = useState("");
  const [searchingTimeout, setSearchingTimeout] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showType, setShowType] = useState({
    type: "table",
    icon: "las la-list-ul",
  });

  let filters = [
    {
      type: "table",
      icon: "las la-list-ul",
    },
    {
      type: "box",
      icon: "las la-icons",
    },
  ];

  const [availables, setAvailables] = useState({
    data: [],
    lastPage: 1,
    currentPage: 1,
    from: 1,
    total: 1,
  });

  const search_coin = (value) => {
    setSearch(value);

    clearTimeout(searchingTimeout);

    setSearchingTimeout(
      setTimeout(() => {
        get_availables(1);
      }, 500)
    );
  };

  /**
   * Get Availables
   */
  const get_availables = async (page) => {
    // start loading
    setLoading(true);

    // set variables
    let url = new URLSearchParams();
    url.set("page", page);

    if (sort.key) {
      url.set("sortColumn", sort.key);
      url.set("sort", sort.type);
    }
    if (search) url.set("search", search);

    await getAvailableCoins(url).then((res) => {
      if (res) {
        setAvailables({
          data: res.available,
          lastPage: res.lastPage,
          currentPage: res.currentPage,
          total: res.total,
        });
      }
    });

    setLoading(false);
  };

  useEffect(() => {
    get_availables(1);
  }, [sort]);

  return (
    <div id="available-coins">
      <PageHeader title="Available Coins" subject="overview and analytics" />
      <Card className="available-coins gutter-b">
        {searchBoxStatus && (
          <div
            className="click-box"
            onClick={() => setSearchBoxStatus(false)}
          ></div>
        )}

        <Card.Header
          className={`with-dropdown search ${searchBoxStatus && "active"}`}
        >
          <span>{availables.total} Coins Available</span>
          <div className="d-flex">
            <InputGroup onClick={() => setSearchBoxStatus(true)}>
              <InputGroup.Text>
                <i className="las la-search"></i>
              </InputGroup.Text>
              <FormControl
                placeholder="Search crypto"
                className="ps-0"
                value={search}
                onChange={(e) => search_coin(e.target.value)}
              />
            </InputGroup>

            {windowSize > 576 && (
              <FilterBox
                filters={filters}
                setFilter={(item) => setShowType(item)}
                active={showType}
                small
                border
              />
            )}
          </div>
        </Card.Header>

        <Card.Body
          className={[
            { "table-padding": showType.type === "table" && windowSize > 576 },
            {
              "mobile-table-padding":
                showType.type === "table" && windowSize <= 576,
            },
          ]}
        >
          {availables.data.length ? (
            <>
              {showType.type === "table" || windowSize <= 576 ? (
                <ListAvailableCoins
                  items={availables.data}
                  apiSort={updateSort}
                />
              ) : (
                <BoxAvailableCoins items={availables.data} />
              )}
            </>
          ) : (
            <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
          )}

          {loading && <BoxLoading />}
        </Card.Body>

        {availables.total > 1 && (
          <Card.Footer>
            <small className="text-muted">
              Showing
              <span className="fw-bolder mx-1">15</span>of
              <span className="fw-bolder mx-1">{availables.total}</span>coins
            </small>
            <Pagination
              currentPage={availables.currentPage - 1}
              lastPage={availables.lastPage}
              changePage={(page) => get_availables(page.selected + 1)}
            />
          </Card.Footer>
        )}
      </Card>
    </div>
  );
}

AvailableCoins.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(AvailableCoins);
